import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { logout, saveLastRoute, showLoginModal } from "./authSlice";

/**
 * REAL baseQuery (function)
 */
const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/",
  credentials: "include",

  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth?.token;

    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

/**
 * Wrapper
 */
export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  if (result?.error?.status === 401) {
    const state = api.getState();

    if (!state.auth.showLoginModal) {
      api.dispatch(saveLastRoute(window.location.pathname));
    //   api.dispatch(logout());
      api.dispatch(showLoginModal());
    }
  }

  return result;
};
